import type { Grouped } from './model';

export type ValueFormat = 'number' | 'aud' | 'percent' | 'decimal';

export type Column = {
  key: string;
  label: string;
  format: ValueFormat;
  value: (values: Record<string, number | null>) => number | null;
};

const whole = new Intl.NumberFormat('en-AU', { maximumFractionDigits: 0 });
const decimal = new Intl.NumberFormat('en-AU', { maximumFractionDigits: 2 });
const aud = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 });
const percent = new Intl.NumberFormat('en-AU', { style: 'percent', maximumFractionDigits: 1 });

/** Missing is shown as Unknown, never as zero. */
export function formatValue(value: number | null, format: ValueFormat): string {
  if (value === null) {
    return 'Unknown';
  }
  if (format === 'aud') {
    return aud.format(value);
  }
  if (format === 'percent') {
    return percent.format(value);
  }
  if (format === 'decimal') {
    return decimal.format(value);
  }
  return whole.format(value);
}

export const sumColumn = (key: string, label: string, format: ValueFormat = 'number'): Column => ({
  key,
  label,
  format,
  value: (values) => values[key] ?? null,
});

export function toCsv(
  title: string,
  range: string,
  dimensionLabel: string,
  rows: ReadonlyArray<Grouped>,
  columns: ReadonlyArray<Column>,
): string {
  const cell = (value: unknown) => `"${String(value ?? 'Unknown').replace(/"/g, '""')}"`;
  const lines = [
    ['Report', `Loyalty Société · ${title}`],
    ['Period', range],
    [dimensionLabel, ...columns.map((column) => column.label)],
    ...rows.map((row) => [row.label, ...columns.map((column) => column.value(row.values) ?? 'Unknown')]),
  ];
  return '﻿' + lines.map((line) => line.map(cell).join(',')).join('\r\n');
}
